import React from 'react';

import dynamic from '@/utils/dynamic';

import { AgendaTemplateProps } from './types';

const Template = dynamic(
  () =>
    import(
      /* webpackChunkName: "agenda-template" */
      './Template'
    ),
);

const AgendaTemplate = (props: AgendaTemplateProps) => {
  return (
    <React.Suspense fallback={null}>
      <Template {...props} />
    </React.Suspense>
  );
};

export default AgendaTemplate;
